var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Olá "+_vm._s(this.$store.state.usuario.usuario.NomeCompleto))]),_vm._v(" "),_c('p',[_vm._v("Enviamos uma mensagem com um link para você acessar o sistema (nesse email a gente define uma senha e no link já deixa ele acessar).")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f91826c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginCpf.vue
// module id = null
// module chunks = 